'use strict';
import $ from 'jquery';
import '../plugins/AccordionPlugin';

export default class M53 {
  static init() {
    $('.module-m53').each((index, el) => {
      new M53($(el));
    });
  }

  constructor($el) {
    this.el = $el;
    const self = this;
    this.initOpenAll();
    this.initFiltration();
    self.el.find('ul.multilevel-accordion li').on('changed', this.resetLink.bind(this));
    setTimeout(() => {
      this.addFloatingCTA();
    }, 500);
  }

  initFiltration() {
    this.el.find('.form-search-roles').on('submit', this.search.bind(this));
  }

  search(e) {
    const self = this;
    self.el.find('.module-m53-no-results').hide();
    e.preventDefault();
    $.ajax({
      method: 'post',
      url: ontraJs.ajaxUrl,
      dataType: 'json',
      data: {
        action: self.el.hasClass('module-m53-job') ? 'ajax_job_filter' : 'ajax_freelance_filter',
        search: self.el.find('input[name=word]').val(),
        location: self.el.find('select').val(),
      },
    }).done(function (resp) {
      if (false === resp.success) {
        self.el.find('.results-items').empty();
        self.el.find('.module-m53-no-results').show();
      } else {
        self.el.find('.results-items').html(resp.contents);
        if (self.el.hasClass('module-m53-job')) {
          self.el.find('ul.multilevel-accordion').slideAccordion({
            opener: '>a.opener',
            slider: '>div.slide',
            collapsible: true,
            animSpeed: 300,
            leaveOthersExpanded: true,
            customOption: false,
          });
          self.el.find('ul.multilevel-accordion li').on('changed', self.resetLink.bind(self));
        }
      }
      self.resetLink();
    });
  }

  initOpenAll() {
    const self = this;
    this.open_all_button = this.el.find('.accordion-open-all');
    this.expand_text = this.open_all_button.text();
    this.el.find('.js-example-placeholder-single').on('change', this.search.bind(this));
    this.el.find('.icon-close.btn-clear-input').on('click', this.search.bind(this));
    this.el.on('click', '.accordion-open-all', (e) => {
      e.preventDefault();
      if (self.el.find('ul.multilevel-accordion li:not(.active)').length === 0) {
        // collapse all
        self.el.find('ul.multilevel-accordion li.active a.opener').trigger('click');
      } else {
        // expand all
        self.el.find('ul.multilevel-accordion a.opener').each((i, a) => {
          if (!$(a).parent().hasClass('active')) $(a).trigger('click');
        });
      }
      this.resetLink();
    });
  }

  resetLink() {
    console.log('resetting link');
    if (this.el.find('ul.multilevel-accordion li.active').length === this.el.find('ul.multilevel-accordion li').length) {
      this.open_all_button.text(this.open_all_button.data('collapse-text'));
    } else {
      this.open_all_button.text(this.expand_text);
    }
  }

  addFloatingCTA() {
    if (!$('body').hasClass('m53-floating-cta')) {
      $('body').addClass('m53-floating-cta');

      this.cta = $('<a>').addClass('module-m53-floating-cta');
      this.cta.html('See Open Roles');
      this.cta.attr('href', '#' + this.el.attr('id'));
      $('body').append(this.cta);

      this.hero_module = $('.modules section:first-child');
      this.hero_module_bottom = this.hero_module.height() + this.hero_module.scrollTop();

      this.cta.on('click', (e) => {
        e.preventDefault();
        $('html,body').animate(
          {
            scrollTop: this.el.position().top,
          },
          {
            duration: 500,
            easing: 'swing',
          }
        );
      });

      $(window).on('scroll', this.onScroll.bind(this));
      this.onScroll();
    }
  }

  onScroll(e) {
    const top = $(window).scrollTop();
    if (top > this.hero_module_bottom && top < this.el.position().top - this.el.height() - 20) {
      this.cta.addClass('show');
    } else {
      this.cta.removeClass('show');
    }
  }
}
